<script lang="ts">import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isTablet, ModalDialog, pushModal } from "@infinitro/global";
import { GoogleIcon } from "@infinitro/icons";
import { Text } from "@infinitro/text";
import { campaignHeroBonus, campaignHeroFeatures } from "../../data/campaign-hero";
import FeatureBadge from "./feature-badge.svelte";
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
$: isPhone = $isMobile && !$isTablet;
// Verbiage.welcome_bonus embeds a literal "\n" (used elsewhere for a 2-line legacy layout);
// this hero renders the headline on a single line, so collapse it to a space instead.
$: formattedTitle = $t(Verbiage.welcome_bonus).replace("\n", " ");
$: formattedSubtext = $t(Verbiage.x_percent_up_to_x_bonus).replaceAll("[BONUS_PERCENT]", campaignHeroBonus.bonusPercent).replaceAll("[BONUS_AMOUNT]", campaignHeroBonus.bonusAmount);
</script>

<div class="content-panel">
	<Text
		type="title"
		titleSize="h1"
		titleWeight="semibold"
		customStyle="font-size: {isPhone ? '40px' : '50px'}; line-height: 1.15; height: auto;"
	>
		{formattedTitle}
	</Text>

	<Text
		type="subtitle"
		subtitleSize="large"
		subtitleWeight="regular"
		customStyle="font-size: {isPhone ? '21px' : '36px'}; line-height: 1.3;"
	>
		{formattedSubtext}
	</Text>

	<div class="feature-row">
		{#each campaignHeroFeatures as feature (feature.label)}
			<FeatureBadge icon={feature.icon} label={feature.label} />
		{/each}
	</div>

	<div class="cta-row">
		<Button
			variant="primary"
			text={$t(Verbiage.rocketbet_register)}
			size="large"
			width={isPhone ? '100%' : '40%'}
			onClick={handleSignup}
		/>
		<Text bodySize="small" bodyWeight="semibold" textColor="gray">{$t(Verbiage.or)}</Text>
		<button
			type="button"
			class="google-button"
			on:click={handleSignup}
			aria-label={$t(Verbiage.rocketbet_register)}
		>
			<GoogleIcon className="google-button-icon" />
		</button>
	</div>
</div>

<style>
	.content-panel {
		display: flex;
		min-height: 250px;
		width: 100%;
		flex-direction: column;
		justify-content: space-around;
		padding-top: 1rem;
		padding-bottom: 1rem
}

	.feature-row {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem
}

	.cta-row {
		margin-top: 1rem;
		display: flex;
		width: 100%;
		align-items: center;
		gap: 0.75rem
}

	.google-button {
		display: flex;
		flex-shrink: 0;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		border-width: 0px;
		width: 44px;
		height: 44px;
		background: white
}

	:global(.google-button-icon) {
		height: 1.5rem;
		width: 1.5rem
}

	@media (min-width: 1024px) {
		.content-panel {
				min-height: 0px;
				justify-content: flex-start;
				gap: 1rem;
				padding-top: 0px;
				padding-bottom: 0px
		}
	}
</style>
